// Components==============
import storePortfolio from 'actions/portfolio/store';
import updatePortfolio from 'actions/portfolio/update';
import { useAlert } from 'hooks/useAlert';
import { useReduxAction } from 'hooks/useReduxAction';
import { useTranslate } from 'hooks/useTranslate';
import { MyWorkContextType } from './MyWork';
// =========================

export type MyWorkFunctions = ReturnType<typeof useMyWorksFunctions>;

export function useMyWorksFunctions({
  selectedPortfolios,
  selectedEvidenceIds,
  setAddModalIsOpen,
  setSelectedEvidenceIds,
  setSelectedPortfolios,
  portfolios,
}: MyWorkContextType) {
  const dispatch = useReduxAction();
  const alert = useAlert();
  const translate = useTranslate();

  function handleAddToPortfolio() {
    selectedEvidenceIds.forEach((id) => {
      dispatch(
        updatePortfolio({
          attachEvidence: true,
          portfolios: selectedPortfolios,
          evidence: id,
        })
      ).then(() => {
        setAddModalIsOpen(false);
        setSelectedEvidenceIds([]);
        setSelectedPortfolios([]);
      });
    });
  }

  function handleAddPortfolio(name: string) {
    const nameExists = portfolios?.map((p) => p?.name).includes(name);

    if (nameExists) return alert(translate('general.terms.name-exists'));

    dispatch(storePortfolio({ name })).then((res: PortfolioEntity) =>
      setSelectedPortfolios((prev) => [...prev, res.id])
    );
  }

  return { handleAddToPortfolio, handleAddPortfolio };
}
